import {createManholeGeometry} from "./manholeGeometry";
import React from "react";
import {Line} from "../../../Renderer/primitives";
import {getClosureSizes} from "../../../../domain/manhole";
import {Group} from "react-konva";

export const renderNoCollarLid = (plan, manhole, scale, lidGeometry) => {
    const mg = createManholeGeometry(manhole, scale, lidGeometry)
    const getHorizontalFrameWidth = () => {
        return plan.lid.type === 'A15' ?
            5.5 * scale :
            plan.lid.type === 'B125' ?
                4 * scale :
                plan.lid.type === "D400" ? 7.1 * scale : plan.lid.type === "E600" ? 7.1 * scale : 0
    }
    const getVerticalFrameWidth = () => {
        return plan.lid.type === 'A15' ?
            0.5 * scale :
            plan.lid.type === 'B125' ?
                0.5 * scale :
                plan.lid.type === "D400" ? 5.6 * scale : plan.lid.type === "E600" ? 5.6 * scale : 0
    }
    const getFrameLeft = () => mg.left - getHorizontalFrameWidth()
    const getFrameRight = () => mg.right+ getHorizontalFrameWidth()
    const getFrameBack = () => mg.top- getVerticalFrameWidth()
    const getFrameFront = () => mg.bottom+ getVerticalFrameWidth()

    const renderFrameOutline = () => <Line points={[getFrameLeft(),
        getFrameBack(),
        getFrameLeft(),
        getFrameFront(),
        getFrameRight(),
        getFrameFront(),
        getFrameRight(),
        getFrameBack(),
        getFrameLeft(),
        getFrameBack()]}/>
    const renderA15 = () => {
        const getFrameWallWidth = () => 0.5 * scale
        const getLeftHorizontalLinePosition = () => mg.left -
            getFrameWallWidth()
        const getRightHorizontalLinePosition = () => mg.right +
            getFrameWallWidth()

        const renderVerticalLines = () => {
            return (<React.Fragment>
                <Line points={[getLeftHorizontalLinePosition(),
                    getFrameFront(),
                    getLeftHorizontalLinePosition(),
                    getFrameBack()]}/>
                <Line points={[getRightHorizontalLinePosition(),
                    getFrameFront(),
                    getRightHorizontalLinePosition(),
                    getFrameBack()]}/>
            </React.Fragment>)
        }
        const renderAnchors = () => {
            const getAnchorLength = () => 2 * scale
            const getAnchorWidth = () => 1.5 * scale
            const getManholeLength = () => manhole.orientation === 'vertical' ?
                manhole.width :
                manhole.height
            const getClosureWidth = () => getClosureSizes(manhole.type).width
            const getClosuresCount = () => Math.round(getManholeLength() / getClosureWidth())
            const getAnchorXPositionCount = () => Math.ceil(getClosuresCount() / 2)
            const getAnchorXPositionsDistance = () => getManholeLength() / getAnchorXPositionCount() * scale
            const getAnchorXPositions = () => {
                return Array(getAnchorXPositionCount()).fill(null).map((_curr, i) => {
                    return (0.5 + i) *
                        getAnchorXPositionsDistance() +
                        mg.left
                })
            }

            return getAnchorXPositions().map((p, i) => {
                return (<React.Fragment key={'lid_ground_view_anchor_' + i}>
                    <Line points={[p,
                        getFrameFront(),
                        p,
                        getFrameFront() + getAnchorLength(),
                        p - getAnchorWidth(),
                        getFrameFront() + getAnchorLength(),
                        p - getAnchorWidth(),
                        getFrameFront()]}/>
                    <Line points={[p,
                        getFrameBack(),
                        p,
                        getFrameBack() - getAnchorLength(),
                        p + getAnchorWidth(),
                        getFrameBack() - getAnchorLength(),
                        p + getAnchorWidth(),
                        getFrameBack()]}/>
                </React.Fragment>)
            })
        }

        return (<React.Fragment>
            {renderVerticalLines()}
            {renderAnchors()}
        </React.Fragment>)
    }
    const renderB125 = () => {
        const getFrameWallWidth = () => 0.5 * scale
        const getLeftHorizontalLinePosition = () => mg.left -
            getFrameWallWidth()
        const getRightHorizontalLinePosition = () => mg.right +
            getFrameWallWidth()

        const renderVerticalLines = () => {
            return (<React.Fragment>
                <Line points={[getLeftHorizontalLinePosition(),
                    getFrameFront(),
                    getLeftHorizontalLinePosition(),
                    getFrameBack()]}/>
                <Line points={[getRightHorizontalLinePosition(),
                    getFrameFront(),
                    getRightHorizontalLinePosition(),
                    getFrameBack()]}/>
            </React.Fragment>)
        }
        const renderAnchors = () => {
            const getManholeLength = () => manhole.orientation === 'vertical' ?
                manhole.width :
                manhole.height
            const getClosureWidth = () => getClosureSizes(manhole.type).width
            const getClosuresCount = () => Math.round(getManholeLength() / getClosureWidth())
            const getAnchorXPositions = () => {
                return Array(getClosuresCount()).fill(null).map((_curr, i) => {
                    return (0.5 + i) * getClosureWidth() * scale + mg.left
                })
            }

            return getAnchorXPositions().map((p, i) => {
                return (<React.Fragment key={'anchor_' + i}>
                    <Line points={[
                        p - 1 * scale,
                        getFrameFront(),
                        p - 1 * scale,
                        getFrameFront() + 3.2 * scale,
                        p,
                        getFrameFront() + 3.2 * scale,
                        p,
                        getFrameFront() + 2 * scale,
                        p + 1 * scale,
                        getFrameFront() + 2 * scale,
                        p + 1 * scale,
                        getFrameFront()
                    ]}/>
                    <Line points={[
                        p + 1 * scale,
                        getFrameBack(),
                        p + 1 * scale,
                        getFrameBack() - 3.2 * scale,
                        p,
                        getFrameBack() - 3.2 * scale,
                        p,
                        getFrameBack() - 2 * scale,
                        p - 1 * scale,
                        getFrameBack() - 2 * scale,
                        p - 1 * scale,
                        getFrameBack()
                    ]}/>
                </React.Fragment>)
            })
        }

        return (<React.Fragment>
            {renderVerticalLines()}
            {renderAnchors()}
        </React.Fragment>)
    }
    const renderD400E600 = () => {
        const renderSupportsAcrossClosures = () => {
            const getManholeLength = () => manhole.orientation === 'vertical' ?
                manhole.width :
                manhole.height
            const getClosureWidth = () => getClosureSizes(manhole.type).width
            const getClosuresCount = () => Math.round(getManholeLength() / getClosureWidth())
            const getSupportXPositions = () => {
                return Array(getClosuresCount() + 1).fill(null).map((_curr, i) => {
                    return i * getClosureWidth() * scale + mg.left
                })
            }

            return getSupportXPositions().map((p, i) => {
                return (<React.Fragment key={'across_support_' + i}>
                    <Line points={[p, mg.top, p, getFrameBack()]}/>
                    <Line points={[p, mg.bottom, p, getFrameFront()]}/>
                </React.Fragment>)
            })
        }
        const renderSupportsAlongClosures = () => {
            const getManholeWidth = () => manhole.orientation === 'horizontal' ?
                manhole.width :
                manhole.height
            const getSupportDistance = () => getManholeWidth() / 5
            const getSupportYPositions = () => {
                return Array(6).fill(null).map((_curr, i) => {
                    return i *
                        getSupportDistance() *
                        scale +
                        mg.clearTop
                })
            }

            return getSupportYPositions().map((p, i) => {
                return (<React.Fragment key={'across_support_' + i}>
                    <Line points={[mg.left, p, getFrameLeft(), p]}/>
                    <Line points={[mg.right, p, getFrameRight(), p]}/>
                </React.Fragment>)
            })
        }

        return (<React.Fragment>
            {renderSupportsAcrossClosures()}
            {renderSupportsAlongClosures()}
        </React.Fragment>)
    }

    return (<Group x={mg.tx}
                   y={mg.ty}
                   rotation={mg.rot}>
        {renderFrameOutline()}
        {plan.lid.type === 'A15' && renderA15()}
        {plan.lid.type === 'B125' && renderB125()}
        {(plan.lid.type === 'D400' || plan.lid.type === 'E600') && renderD400E600()}
    </Group>)
}